import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';

const { white } = Colors;

export const SidebarContainerActivities = styled.section`
    max-height: 500px;
    overflow-y: auto;
    background-color: ${white};
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #f3f4f6ff;
    box-shadow: 0px 10px 20px -15px #171a1f;
    width: 100%;
`;

export const SidebarContainerDropdowns = styled.section<{ mobile: boolean }>`
    max-height: 500px;
    background-color: ${({ mobile }) => (mobile ? '#F8F9FAFF' : white)};
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;
